import React, { useMemo } from "react";
import { CheckCheck, Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { fmtTime } from "../../lib/chat";

/* 自己消息气泡下方：发送时间 · 已读 N 人（群 / 部门频道点开看名单；私聊只显示 已读 / 未读）。口径：成员中除自己外 lastReadSeq ≥ 该消息 seq */
export const ReadReceipt = ({ m, me, zh, reads, members, chType }) => {
  const { read, unread } = useMemo(() => {
    const others = (members || []).filter((u) => u.username !== me);
    const r = reads || {};
    return { read: others.filter((u) => (r[u.username] || 0) >= (m.seq || 0)), unread: others.filter((u) => (r[u.username] || 0) < (m.seq || 0)) };
  }, [members, reads, me, m.seq]);
  const nm = (u) => (zh ? (u.nameZh || u.name) : (u.name || u.nameZh)) || u.username;
  const total = read.length + unread.length;
  const allRead = total > 0 && unread.length === 0;
  const Icon = allRead ? CheckCheck : Check;
  const label = chType === "dm" ? (read.length ? (zh ? "已读" : "Read") : (zh ? "未读" : "Unread")) : (zh ? `已读 ${read.length} 人` : `Read by ${read.length}`);
  return (
    <div className="mt-0.5 flex items-center gap-1.5 text-[11px] text-slate-500" data-testid={`chat-receipt-${m.id}`} data-read={read.length} data-total={total}>
      <span data-testid={`chat-sent-time-${m.id}`} title={m.createdAt}>{fmtTime(m.createdAt)}{m.editedAt ? (zh ? " · 已编辑" : " · edited") : ""}</span>
      <span aria-hidden="true">·</span>
      {chType === "dm" || total === 0 ? (
        <span className={`inline-flex items-center gap-0.5 ${allRead ? "text-emerald-700" : ""}`} data-testid={`chat-read-count-${m.id}`}><Icon className="h-3 w-3" />{total === 0 ? (zh ? "仅自己" : "Only you") : label}</span>
      ) : (
        <Popover>
          <PopoverTrigger asChild>
            <button type="button" data-testid={`chat-read-count-${m.id}`} className={`inline-flex items-center gap-0.5 rounded-full px-1 -mx-1 hover:bg-slate-100 hover:text-slate-800 ${allRead ? "text-emerald-700" : ""}`}><Icon className="h-3 w-3" />{label}</button>
          </PopoverTrigger>
          <PopoverContent align="start" sideOffset={4} className="z-[10001] w-64 p-3 text-xs rounded-2xl border border-slate-200 bg-white shadow-xl" data-testid={`chat-read-list-${m.id}`}>
            <p className="font-semibold text-slate-800 mb-1.5 inline-flex items-center gap-1"><CheckCheck className="h-3.5 w-3.5 text-emerald-600" />{zh ? `已读 ${read.length} / ${total}` : `Read ${read.length} / ${total}`}</p>
            <p className="text-slate-700 leading-relaxed break-words" data-testid={`chat-read-names-${m.id}`}>{read.length ? read.map(nm).join("、") : (zh ? "还没有人读过" : "No one yet")}</p>
            {unread.length > 0 && <>
              <p className="font-semibold text-slate-800 mt-2.5 mb-1.5">{zh ? `未读 ${unread.length}` : `Unread ${unread.length}`}</p>
              <p className="text-slate-500 leading-relaxed break-words" data-testid={`chat-unread-names-${m.id}`}>{unread.map(nm).join("、")}</p>
            </>}
          </PopoverContent>
        </Popover>
      )}
    </div>
  );
};
